
import React, { useState, useEffect, useContext } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import '../css/StockDiarDzairPage.css'
import TacheTout from '../svg/tacheSVG/TacheTout';
import LoadingComponent from '../components/LoadingComponent';
import { color } from 'chart.js/helpers';
import VerificationPage from '../components/VerificationPage';
import ModifierClientStock from '../components/ModifierClientStock';

function StockDiarDzairPage() {
    const navigate = useNavigate();
    const { page = 1 } = useParams();
    const [pages, setPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(50);

    const [vehicules, setVehicules] = useState([]);
    const [filter, setFilter] = useState(0);
    const [tableShow, setTableShow] = useState(false);
    const [consultGroupList, setConsultGroupList] = useState([]);

    const [verificationPageActive, setVerificationPageActive] = useState(false);
    const [modifierClientStockActive, setModifierClientStockActive] = useState(false);
    const [clientId, setClientId] = useState("");
    const [vehiculeId, setVehiculeId] = useState("");

    useEffect(() => {
        getVehicules();
    }, [page, filter])

    useEffect(() => {
        if (parseInt(page) <= parseInt(pages) - 3) {
            setPageNumber(parseInt(page));
        } else {
            setPageNumber(parseInt(pages) - 3)
        }
    }, [page, pages])

    useEffect(() => {
        navigate(`/banque/stock_dd/page/${1}`);
        setConsultGroupList([]);
    }, [filter])

    // useEffect(() => {
    //     console.log(clientId);
    // }, [clientId])

    const addConsultGroup = (vehicule_id) => {
        var idx = consultGroupList.indexOf(vehicule_id);
        if (idx > -1) {
            setConsultGroupList(t => t.filter(item => item !== vehicule_id));
        } else {
            setConsultGroupList(t => [...t, vehicule_id]);
        }
    }

    function onclickNext() {
        if (page < pages) {
            navigate(`/banque/stock_dd/page/${parseInt(page) + 1}`)
        }
    }

    function onclickPrevious() {
        if (page > 1) {
            navigate(`/banque/stock_dd/page/${parseInt(page) - 1}`)
        }
    }

    const getVehicules = async () => {
        var cp = page || 1;
        setTableShow(false);
        await axios
            .post(`http://localhost:8000/api/vehicule/unverifiedVehicules?page=${cp}`,
                JSON.stringify({ username: 'ghsggs&@gdsfd', password: 'hdgs@&hdjshus@sq', type: filter }),
                {
                    headers: {
                        //'Content-Type': 'application/x-www-form-urlencoded'
                        'Content-Type': 'application/json'
                    },
                })
            .then((res) => {
                setVehicules(res.data.vehicules.data);
                setPages(res.data.vehicules.last_page);
                setTableShow(true);
            })
            .catch((err) => {
                setTableShow(false);
                console.log(err);
            });

    }

    const refreshHandle = () => {
        setConsultGroupList([]);
    }

    const selectAll = () => {
        vehicules.map(veh => {
            var idx = consultGroupList.indexOf(veh.id);
            if (idx == -1) {
                setConsultGroupList(t => [...t, veh.id])
            }
        })
    }

    const modifierClientHandler = (id_vehicule, id_client) => {
        if (id_client) {
            setClientId(id_client);
        } else {
            setClientId("");
        }
        setVehiculeId(id_vehicule);
        setModifierClientStockActive(true);
    }

    return (
        <div className="stock-dd-page">
            <div className="row">
                {/*   Begin Tâches  */}
                <div className="col-xl-2 col-lg-12 padding-right margin-bottom">
                    <div className="taches-section">
                        <h2>Filtre</h2>
                        <ul>
                            <li onClick={() => setFilter(0)} className={filter === 0 ? 'tache-active' : ''}>
                                <div className="no-color">
                                    <TacheTout color={"no-color"} />
                                    <span>Non Vérifiées</span>
                                </div>
                                <div className="with-color">
                                    <TacheTout color={"with-color"} />
                                    <span>Non Vérifiées</span>
                                </div>
                            </li>
                            <li onClick={() => setFilter(1)} className={filter === 1 ? 'tache-active' : ''}>
                                <div className="no-color">
                                    <TacheTout color={"no-color"} />
                                    <span>Vérifiées</span>
                                </div>
                                <div className="with-color">
                                    <TacheTout color={"with-color"} />
                                    <span>Vérifiées</span>
                                </div>
                            </li>

                        </ul>
                    </div>
                </div>

                <div className="col-xl-10 col-lg-12 padding-left margin-bottom">
                    <div className="commands-section">
                        <h2>Tableau des Vehicules</h2>

                        <div className='download-table'>
                            {
                                filter === 0 && (
                                    <>
                                        <span onClick={() => setVerificationPageActive(true)} style={{ display: consultGroupList.length === 0 ? 'none' : '' }}>Verification</span>
                                        <span onClick={refreshHandle} className='right-side'>Rafraîchir</span>
                                        <span onClick={selectAll} className='right-side'>Sélé Tout</span>
                                        <VerificationPage verificationPageActive={verificationPageActive} setVerificationPageActive={setVerificationPageActive} consultGroupList={consultGroupList} getVehicules={getVehicules} refreshHandle={refreshHandle} />
                                    </>
                                )
                            }
                            <ModifierClientStock modifierClientStockActive={modifierClientStockActive} setModifierClientStockActive={setModifierClientStockActive} getVehicules={getVehicules} refreshHandle={refreshHandle} clientId={clientId} setClientId={setClientId} vehiculeId={vehiculeId} />
                        </div>

                        {/* Begin Table  */}
                        {
                            tableShow ?
                                (vehicules?.length !== 0) ?
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                {
                                                    consultGroupList.length > 0 ? (<th style={{ color: "#4CAF50", fontWeight: "500", fontSize: "15px" }}>{consultGroupList.length}</th>)
                                                        : <th></th>
                                                }
                                                <th>ID</th>
                                                <th>Magasin</th>
                                                <th>Fournisseur</th>
                                                <th>Num Châssis</th>
                                                <th>Designation</th>
                                                <th>Matricule</th>
                                                <th>Couleur</th>
                                                <th>Client</th>
                                                <th>Date</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                vehicules?.map((vehicule, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <div className={consultGroupList.indexOf(vehicule.id) > -1 ? 'mini-rect-div active' : 'mini-rect-div'} onClick={() => addConsultGroup(vehicule.id)}></div>
                                                        </td>
                                                        <td>{vehicule.id}</td>
                                                        <td>{vehicule.store.label}</td>
                                                        <td>{vehicule.supplier.first_name}</td>
                                                        <td>{vehicule.num_chasse}</td>
                                                        <td>{vehicule.designation}</td>
                                                        <td>{vehicule.matricule}</td>
                                                        <td>{vehicule.couleur}</td>
                                                        <td>{vehicule.client_id}</td>
                                                        <td>{vehicule.created_at.slice(0, 10)}</td>
                                                        <td>
                                                            <span onClick={() => modifierClientHandler(vehicule.id, vehicule.client_id)}>Modifier</span>
                                                        </td>
                                                    </tr>
                                                )
                                                )
                                            }
                                        </tbody>
                                    </table>
                                    : <div className='no-data-wrapper'>Pas de Données Disponibles</div>
                                : (
                                    <LoadingComponent />
                                )
                        }
                        {/* End Table */}

                        {/* Begin Pagination */}
                        {
                            (tableShow && pages && pages > 1) ? (
                                <div className="pagination">
                                    {
                                        parseInt(pages) <= 8 ? (
                                            <div className="pagination-content">
                                                <span onClick={onclickPrevious}>
                                                    <i className="fa-solid fa-angle-left"></i>
                                                </span>
                                                <span onClick={() => navigate(`/banque/page/${1}`)} > Premier </span>
                                                {
                                                    [...Array(pages).keys()].map(x => (
                                                        <span key={x + 1} className={x + 1 == page ? 'page-number-active' : ''} onClick={() => navigate(`/banque/page/${x + 1}`)}>
                                                            {x + 1}
                                                        </span>
                                                    ))
                                                }
                                                <span onClick={() => navigate(`/banque/page/${pages}`)} > Dernier </span>
                                                <span onClick={onclickNext} >
                                                    <i className="fa-solid fa-angle-right"></i>
                                                </span>
                                            </div>
                                        ) :
                                            (
                                                <div className="pagination-content">
                                                    <span onClick={onclickPrevious}>
                                                        <i className="fa-solid fa-angle-left"></i>
                                                    </span>
                                                    <span onClick={() => navigate(`/banque/stock_dd/page/${1}`)} > Premier </span>
                                                    {
                                                        (pageNumber - 1 > 0) && (
                                                            <span onClick={() => navigate(`/banque/stock_dd/page/${pageNumber - 1}`)} > {pageNumber - 1} </span>
                                                        )
                                                    }
                                                    {
                                                        pageNumber && (
                                                            <span className={pageNumber == page ? 'page-number-active' : ''} onClick={() => navigate(`/banque/stock_dd/page/${pageNumber}`)}>
                                                                {pageNumber}
                                                            </span>
                                                        )
                                                    }
                                                    {
                                                        (pageNumber + 1 <= pages) && (
                                                            <span className={pageNumber + 1 == page ? 'page-number-active' : ''} onClick={() => navigate(`/banque/stock_dd/page/${pageNumber + 1}`)}>
                                                                {pageNumber + 1}
                                                            </span>
                                                        )
                                                    }
                                                    {
                                                        (pageNumber === 1) && (
                                                            <span onClick={() => navigate(`/banque/stock_dd/page/${pageNumber + 2}`)}>{pageNumber + 2}</span>
                                                        )
                                                    }
                                                    {
                                                        (pageNumber + 1 !== pages - 2) && (
                                                            <span>{'....'}</span>
                                                        )
                                                    }
                                                    <span onClick={() => navigate(`/banque/stock_dd/page/${pages - 1}`)} className={pages - 1 == page ? 'page-number-active' : ''}>
                                                        {pages - 1}
                                                    </span>
                                                    <span onClick={() => navigate(`/banque/stock_dd/page/${pages}`)} className={pages == page ? 'page-number-active' : ''}>
                                                        {pages}
                                                    </span>
                                                    <span onClick={() => navigate(`/banque/stock_dd/page/${pages}`)} > Dernier </span>
                                                    <span onClick={onclickNext} >
                                                        <i className="fa-solid fa-angle-right"></i>
                                                    </span>
                                                </div>
                                            )
                                    }
                                </div>
                            ) : ""
                        }
                        {/* End Pagination */}

                    </div>
                </div>

            </div>

        </div>
    )
}
export default StockDiarDzairPage